import axios from "axios";
import BASE_URL from "../../config";

// Get the auth token from localStorage and return headers
const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

// API to fetch daily summary report
export const getDailySummary = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/DailySummary/get`, filter, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching daily summary:", error);
    throw error;
  }
};

// API to fetch invoice details for a specific date
export const getDailySummaryDetails = async (request = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/DailySummary/get-details`, request, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching daily summary details:", error);
    throw error;
  }
};

// API to export daily summary to Excel
export const exportDailySummaryToExcel = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/DailySummary/export-excel`, filter, {
      headers: getAuthHeader(),
      responseType: 'blob'
    });
    
    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `DailySummaryReport_${new Date().toISOString().slice(0,19).replace(/[-:]/g, '').replace('T', '_')}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    
    return true;
  } catch (error) {
    console.error("Error exporting daily summary:", error);
    throw error;
  }
};

// API to export daily summary details to Excel
export const exportDailySummaryDetailsToExcel = async (request = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/DailySummary/export-details-excel`, request, {
      headers: getAuthHeader(),
      responseType: 'blob'
    });
    
    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    const dateStr = request.date ? new Date(request.date).toISOString().slice(0,10).replace(/-/g, '') : '';
    link.setAttribute('download', `DailySummaryDetails_${dateStr}_${new Date().toISOString().slice(0,19).replace(/[-:]/g, '').replace('T', '_')}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    
    return true;
  } catch (error) {
    console.error("Error exporting daily summary details:", error);
    throw error;
  }
};






